module.exports = __webpack_public_path__ + "img/roleMgt.65fc5ef2.svg";